var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_62_2729)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.4448 9.08602V26.3313L45.409 17.6909V0.445312L30.4448 9.08602Z",
    fill: "#13A049"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.4449 9.08602L15.481 0.445312V17.7267L30.4449 26.3674V9.08602Z",
    fill: "#A2CC39"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M45.409 0.445312L30.4449 9.08602L15.481 0.445312L0.516846 9.08602L30.4449 26.3674L60.3551 9.08602L45.409 0.445312Z",
    fill: "url(#paint0_linear_62_2729)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4449 26.3673L0.516846 9.08594V26.3673L15.481 35.008V52.2716L30.4449 60.9123L45.409 52.2716V35.008L60.3551 26.3673V9.08594L30.4449 26.3673Z",
    fill: "url(#paint1_linear_62_2729)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4448 26.3673V60.9123L45.409 52.2716V35.008L60.355 26.3673V9.08594L30.4448 26.3673Z",
    fill: "url(#paint2_linear_62_2729)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M30.4448 43.6309V60.9123L45.409 52.2716L30.4448 43.6309Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.4449 60.9484V43.667L15.481 52.3077L30.4449 60.9484Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M15.481 17.7266L0.516846 26.3673L15.481 35.008L30.4449 26.3673L15.481 17.7266Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M45.409 17.7266L30.4448 26.3673L45.409 35.008L60.355 26.3673L45.409 17.7266Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_2729",
    x1: 60.3623,
    y1: 13.404,
    x2: 0.516846,
    y2: 13.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37BDA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AD3B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_62_2729",
    x1: 60.3623,
    y1: 34.9981,
    x2: 0.516846,
    y2: 34.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4BB6AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78BBC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_62_2729",
    x1: 30.4394,
    y1: 34.9981,
    x2: 60.3619,
    y2: 34.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4379A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CC9B8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62_2729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60.7031,
    fill: "white",
    transform: "translate(0.516846 0.445312)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.c0467752d8042eb141d81f6138dd2895.svg";
export { ForwardRef as ReactComponent };